/**
 * Bootstrap 5 Modules
 * 說明：
 * 這是 Bootstrap 5 的自定義引入檔案。
 * 您可以註解掉不需要的模組以減少 JS 檔案大小。
 */

import * as bootstrap from 'bootstrap';

// import Alert from 'bootstrap/js/dist/alert';
// import Button from 'bootstrap/js/dist/button';
// import Carousel from 'bootstrap/js/dist/carousel';
// import Collapse from 'bootstrap/js/dist/collapse';
// import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
// import Offcanvas from 'bootstrap/js/dist/offcanvas';
// import Popover from 'bootstrap/js/dist/popover';
// import ScrollSpy from 'bootstrap/js/dist/scrollspy';
// import Tab from 'bootstrap/js/dist/tab';
// import Toast from 'bootstrap/js/dist/toast';
import Tooltip from 'bootstrap/js/dist/tooltip';

// 預設啟用所有模組 (可以依需求註解掉不需要的)
import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
import 'bootstrap/js/dist/popover';
import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/toast';


document.addEventListener('DOMContentLoaded', () => {
  // 初始化所有 Tooltip
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltipTriggerList.forEach((tooltipTriggerEl) => {
    new Tooltip(tooltipTriggerEl, {
      container: 'body',
      trigger: 'hover', // 只在 hover 時觸發，避免 mobile 點擊問題
    });
  });

  // 初始化所有 Modal
  const modalTriggerList = document.querySelectorAll('[data-bs-toggle="modal"]');
  modalTriggerList.forEach((modalTriggerEl) => {
    const isHeaderModal = modalTriggerEl.closest('#header');
    if (isHeaderModal) return;
    new Modal(modalTriggerEl);
  });
});

// 需要使用 Bootstrap 的全域變數
window.bootstrap = bootstrap;
